import { handleActions } from 'redux-actions';
import {
  setSponsorError,
  setSponsorList,
  fetchSponsorList,
  setSponsorFilters,
  setSponsorOptions,
} from './actions';

const defaultState = {
  loading: false,
  filters: {
    pageNumber: 1,
    pageSize: 10,
    sortBy: '',
    search: '',
    isSortOrderDescending: false,
    status: null,
  },
  totalRecords: 0,
  data: [],
  sponsorOptions: [],
  options: [],
  error: null,
};

export default handleActions(
  {
    [fetchSponsorList](state) {
      return {
        ...state,
        loading: true,
        data: [],
      };
    },
    [setSponsorList](state, { payload }) {
      return {
        ...state,
        loading: false,
        data: payload.data.records,
        totalRecords: payload.data.totalRecords,
        error: null,
      };
    },
    [setSponsorError](state, { payload }) {
      return {
        ...state,
        data: [],
        loading: false,
        totalPages: defaultState.totalPages,
        error: payload?.message,
      };
    },
    [setSponsorOptions](state, { payload }) {
      return {
        ...state,
        sponsorOptions: payload.data?.records,
      };
    },
    [setSponsorFilters](state, { payload }) {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...payload,
        },
      };
    },
  },
  defaultState,
);
